/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
//@ts-ignore
import { BlackCoins } from "../../assets/icons/BlackCoins.jsx";
import { EmptyReferralTimeline } from "../../assets/icons/EmptyReferralTimeline";
//@ts-ignore
import {useTrack} from "../../services/hooks/useTrack"

interface ITransaction {
  date: string;
  description: string;
  image: string;
  note: string;
  status: string;
  title: string;
  type: string;
  value: string;
  _id: string;
  metadata: {
    product: {
      brand: string;
      type: string;
      value: string;
    };
  };
}

interface IProps {
  transactions: ITransaction[];
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  padding-right: 10px;
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #585757;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #1e1e1e;
    border: 2px solid #585757;
    border-radius: 30px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #1e1e1e;
  }
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 20px;
  background-color: #1e1e1e;
`;

const Image = styled.img`
  height: 50px;
  width: 90px;
  object-fit: cover;
  border-radius: 15px;
`;

const TitleContainer = styled.div`
  color: white;
`;

const Title = styled.p`
  font-size: 18px;
  font-weight: 700;
`;

const SubTitle = styled.p`
  font-weight: 300;
  font-size: 14px;
  white-space: nowrap;
  b {
    font-weight: 700;
  }
`;

const StatusContainer = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
`;

const StatusTitle = styled.p`
  font-weight: 300;
  font-size: 14px;
  white-space: nowrap;
`;

const StatusDate = styled.p`
  font-size: 14px;
  white-space: nowrap;
`;

const StatusNotes = styled.p`
  font-size: 12px;
  font-weight: 300;
  white-space: nowrap;
`;

const PriceContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Price = styled.p`
  color: white;
  font-size: 18px;
  b {
    color: #00ff37;
  }
`;

const EmptyContainer = styled.div`
  background-color: #1e1e1e50;
  border-radius: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

const EmptyText = styled.p`
  color: #6f6f6f;
  font-weight: 700;
`;


export const Timeline = (props: IProps) => {
  const {trackEvent} = useTrack();

  useEffect(() => {
    trackEvent('Indique - Visualizou modal Meu Histórico')
  }, [])
  return (
    <>
      {props.transactions.length > 0 ? (
        <Container>
          {props?.transactions?.map((transaction) => (
            <Item>
              <Image
                src={
                  transaction.image
                    ? transaction.image
                    : require("../../assets/images/fallbackStoreImage.png")
                }
              />
              <TitleContainer>
                <Title>
                  {transaction.metadata.product
                    ? transaction.metadata.product.brand
                    : transaction.title}
                </Title>
                {transaction.metadata.product ? (
                  <SubTitle>
                    {transaction.metadata.product.type === "physical"
                      ? "Livro"
                      : "Gift Card"}{" "}
                    <b>
                      {transaction.metadata.product.type === "physical"
                        ? ""
                        : transaction.metadata.product.value + "R$"}
                    </b>
                  </SubTitle>
                ) : (
                  <SubTitle>{transaction.description}</SubTitle>
                )}
              </TitleContainer>
              <StatusContainer>
                <StatusTitle>{transaction.status}</StatusTitle>
                <StatusDate>{transaction.date}</StatusDate>
                <StatusNotes>{transaction.note}</StatusNotes>
              </StatusContainer>
              <PriceContainer>
                <BlackCoins />
                {transaction.value.includes("+") ? (
                  <Price>
                    <b>{transaction.value}</b>
                  </Price>
                ) : (
                  <Price>{transaction.value}</Price>
                )}
              </PriceContainer>
            </Item>
          ))}
        </Container>
      ) : (
        <EmptyContainer>
          <EmptyReferralTimeline />
          <EmptyText>Seu histórico está vazio por enquanto</EmptyText>
        </EmptyContainer>
      )}
    </>
  );
};
